var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{class:_vm.classes,attrs:{"role":"separator","aria-orientation":_vm.vertical ? 'vertical' : 'horizontal'}})}
var staticRenderFns = []

export { render, staticRenderFns }